// ----------------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//        Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------------
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { InfoBuffer } from './buffer';
export class InstrumentService {
    getProvider(name) {
        let providerName = name ? name : 'static';
        return this.provider[providerName];
    }
    addProvider(provider) {
        let name = provider.name;
        if (this.provider[name] !== undefined) {
            return false;
        }
        this.provider[name] = provider;
        return true;
    }
    updateProvider(provider) {
        let name = provider.name;
        if (this.provider[name] === undefined) {
            return false;
        }
        this.provider[name] = provider;
        return true;
    }
    removeProvider(name) {
        this.provider[name] = undefined;
    }
    getConsumerService(name) {
        return this.service[name];
    }
    addConsumerService(ConsumerService) {
        let name = ConsumerService.name;
        if (this.service[name] !== undefined) {
            return false;
        }
        this.service[name] = ConsumerService;
        return true;
    }
    updateConsumerService(service) {
        let name = service.name;
        if (this.service[name] === undefined) {
            return false;
        }
        this.service[name] = service;
        return true;
    }
    removeConsumerService(name) {
        this.service[name] = undefined;
    }
    // its not private, its public.
    constructor(){
        _define_property(this, "name", void 0);
        _define_property(this, "provider", void 0);
        _define_property(this, "service", void 0);
        _define_property(this, "systemInfo", void 0);
        this.name = 'instrumentService';
        this.provider = {};
        this.service = {};
        this.systemInfo = new InfoBuffer();
    }
}
